// extracted by mini-css-extract-plugin
module.exports = {"main":"CurrentLocation_main__PP4_M","text":"CurrentLocation_text__28M4R"};